var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9514 20.7721L19.6189 18.4396C19.3719 18.1926 18.9877 18.1378 18.686 18.2749L17.5061 17.0951C19.235 15.3117 20.3051 12.8421 20.3051 10.1528C20.3051 4.55495 15.7501 0 10.1523 0C4.55495 0.000217262 0 4.55522 0 10.1528C0 15.7507 4.555 20.3056 10.1528 20.3056C12.8418 20.3056 15.3114 19.2356 17.1223 17.5069L18.3022 18.6867C18.1651 18.9885 18.2198 19.3727 18.4669 19.6197L20.7993 21.9522C21.1285 22.2814 21.65 22.2814 21.9518 21.9522C22.2534 21.6228 22.281 21.1013 21.9516 20.7721L21.9514 20.7721ZM10.1527 19.2079C5.15884 19.2079 1.09788 15.1468 1.09788 10.1531C1.09788 5.15939 5.15901 1.09827 10.1527 1.09827C15.1464 1.09827 19.2075 5.15939 19.2075 10.1531C19.2075 15.1472 15.1466 19.2079 10.1527 19.2079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a18030a12b101d1439e0985ba3183f14.svg";
export { ForwardRef as ReactComponent };